import { SwiadczeniobiorcyFilter } from '../../shared/enums/application-list-swiadczeniobiorcy.enum';
import { Application } from '../../shared/models/application';
import { PrzedsiebiorcyFilter } from '../../shared/enums/application-list-przedsiebiorcy.enum';
import { APPLICATION_CATEGORY } from '../../shared/models/custom-types';
import { ApplicationCode } from '../../shared/enums/application_code';

export const AKTYWNY_RODZIC_APPLICATION_LIST: Application[] = [
  new Application(
    1096,
    'SW',
    'AWD',
    ApplicationCode.AWD,
    'Wniosek o świadczenie Aktywnie w domu',
    false,
    'SW',
  ),
  new Application(
    1097,
    'SW',
    'AWP',
    ApplicationCode.AWP,
    'Wniosek o świadczenie Aktywni rodzice w pracy',
    false,
    'SW',
  ),
  new Application(
    1086,
    'SW',
    'AWZ',
    ApplicationCode.AWZ,
    'Wniosek o świadczenie Aktywnie w żłobku',
    false,
    'SW',
  ),
];

export const DOBRY_START_APPLICATION_LIST = [
  new Application(
    1029,
    'SW',
    'DS-R',
    ApplicationCode.DS_R,
    'Wniosek o ustalenie prawa do świadczenia dobry start',
    false,
    'SW',
  ),
];

export const SWIADCZENIA_RODZINNE_APPLICATION_LIST = [
  new Application(
    1081,
    'SR',
    'NSR-5',
    ApplicationCode.NSR_5,
    'Wniosek o ustalenie prawa do świadczenia pielęgnacyjnego na zasadach obowiązujących od 1 stycznia 2024 r.',
    false,
    'SR',
  ),
  new Application(
    1050,
    'SR',
    'SR-1',
    ApplicationCode.SR_1,
    'Zasiłek Rodzinny i dodatki do Zasiłku Rodzinnego',
    false,
    'SR',
  ),
  new Application(
    1030,
    'SR',
    'SR-2',
    ApplicationCode.SR_2,
    'Jednorazowa zapomoga z tytułu urodzenia się dziecka (Becikowe)',
    false,
    'SR',
  ),
  new Application(
    1053,
    'SR',
    'SR-3',
    ApplicationCode.SR_3,
    'Zasiłek Pielęgnacyjny',
    false,
    'SR',
  ),
  new Application(
    1001,
    'SR',
    'SR-4',
    ApplicationCode.SR_4,
    'Wniosek o ustalenie prawa do specjalnego zasiłku opiekuńczego',
    false,
    'SR',
  ),
  new Application(
    1032,
    'SR',
    'SR-5',
    ApplicationCode.SR_5,
    'Wniosek o ustalenie prawa do świadczenia pielęgnacyjnego na zasadach obowiązujących do 31 grudnia 2023 r.',
    false,
    'SR',
  ),
  new Application(
    1024,
    'SR',
    'SR-7',
    ApplicationCode.SR_7,
    'Wniosek o ustalenie prawa do świadczenia rodzicielskiego',
    false,
    'SR',
  ),
  new Application(
    1077,
    'SR',
    'SR-8',
    ApplicationCode.SR_8,
    'Wniosek o ustalenie prawa do jednorazowego świadczenia z tytułu urodzenia się dziecka, u którego zdiagnozowano ciężkie i nieodwracalne upośledzenie albo nieuleczalną chorobę zagrażającą życiu, które powstały w prenatalnym okresie rozwoju dziecka lub w czasie porodu',
    false,
    'SR',
  ),
  new Application(
    1047,
    'ZS',
    'ZS-1',
    ApplicationCode.ZS_1,
    'Wniosek o wydanie zaświadczenia o udzielonej pomocy',
    false,
    'SR',
  ),
  new Application(
    1000,
    'ZS',
    'ZS-2',
    ApplicationCode.ZS_2,
    'Wniosek o umorzenie należności (w części lub w całości), rozłożenie na raty spłaty należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami realizowanymi odpłatnie)',
    false,
    'SR',
  ),
];

export const KARTA_DUZEJ_RODZINY_APPLICATION_LIST = [
  new Application(
    1052,
    'KDR',
    'KDR',
    ApplicationCode.KDR,
    'Wniosek o ustalenie prawa do Ogólnopolskiej Karty Dużej Rodziny - system zniżek dla rodzin wielodzietnych',
    false,
    'KDR',
  ),
];

export const SWIADCZENIA_WYCHOWAWCZE_APPLICATION_LIST = [
  new Application(
    1071,
    'SW',
    'SW-R',
    ApplicationCode.SW_R,
    'Wniosek o Świadczenie Wychowawcze (Program „Rodzina 800+”)',
    false,
    'SW',
  ),
];

export const SWIADCZENIA_WSPIERAJACE_APPLICATION_LIST = [
  new Application(
    1083,
    'PPW',
    'PPW',
    ApplicationCode.PPW,
    'Wniosek o wydanie decyzji ustalającej poziom potrzeby wsparcia',
    false,
    'PPW',
  ),
  new Application(
    1085,
    'PPW',
    'SWN',
    ApplicationCode.SWN,
    'Wniosek o świadczenie wspierające',
    false,
    'PPW',
  ),
];

export const FUNDUSZ_ALIMENTACYJNY_APPLICATION_LIST = [
  new Application(
    1002,
    'FA',
    'FA-1',
    ApplicationCode.FA_1,
    'Wniosek o ustalenie prawa do świadczeń z funduszu alimentacyjnego',
    false,
    'FA',
  ),
  new Application(
    1047,
    'ZS',
    'ZS-1',
    ApplicationCode.ZS_1,
    'Wniosek o wydanie zaświadczenia o udzielonej pomocy',
    false,
    'FA',
  ),
  new Application(
    1000,
    'ZS',
    'ZS-2',
    ApplicationCode.ZS_2,
    'Wniosek o umorzenie należności (w części lub w całości), rozłożenie na raty spłaty należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami realizowanymi odpłatnie)',
    false,
    'FA',
  ),
  new Application(
    1048,
    'ZS',
    'ZS-3',
    ApplicationCode.ZS_3,
    'Zgłoszenie nieprawidłowości o udzielonej pomocy',
    false,
    'FA',
  ),
  new Application(
    1049,
    'ZS',
    'ZS-4',
    ApplicationCode.ZS_4,
    'Wniosek o zmianę decyzji lub postanowienia',
    true,
    'FA',
  ),
];

export const POMOC_SPOLECZNA_APPLICATION_LIST = [
  new Application(
    1005,
    'PS',
    'PS-1',
    ApplicationCode.PS_1,
    'Wniosek o przyznanie pomocy społecznej',
    false,
    'PS',
  ),
  new Application(
    1007,
    'PS',
    'PS-2',
    ApplicationCode.PS_2,
    'Powiadomienie o zmianie sytuacji życiowej',
    false,
    'PS',
  ),
  new Application(
    1008,
    'PS',
    'PS-3',
    ApplicationCode.PS_3,
    'Informacja o potrzebie przyznania pomocy społecznej innej osobie/rodzinie',
    false,
    'PS',
  ),
  // new Application(
  //   1074,
  //   'PS',
  //   'PS-U',
  //   ApplicationCode.PS_U,
  //   'Pomoc jednorazowa dla obywateli Ukrainy w wysokości 300 zł na osobę',
  //   false,
  //   'PS',
  // ),
  new Application(
    1047,
    'ZS',
    'ZS-1',
    ApplicationCode.ZS_1,
    'Wniosek o wydanie zaświadczenia o udzielonej pomocy',
    false,
    'PS',
  ),
  new Application(
    1000,
    'ZS',
    'ZS-2',
    ApplicationCode.ZS_2,
    'Wniosek o umorzenie należności (w części lub w całości), rozłożenie na raty spłaty należności, odroczenie terminu płatności, zwolnienie lub zmniejszenie odpłatności (w związku z nienależnymi świadczeniami lub świadczeniami realizowanymi odpłatnie)',
    false,
    'PS',
  ),
  new Application(
    1048,
    'ZS',
    'ZS-3',
    ApplicationCode.ZS_3,
    'Zgłoszenie nieprawidłowości o udzielonej pomocy',
    false,
    'PS',
  ),
  new Application(
    1049,
    'ZS',
    'ZS-4',
    ApplicationCode.ZS_4,
    'Wniosek o zmianę decyzji lub postanowienia',
    true,
    'PS',
  ),
];

export const OPIEKA_NAD_DZIECKIEM_DO_LAT_3_APPLICATION_LIST = [
  new Application(
    1021,
    'OP',
    'RKZ-1',
    ApplicationCode.RKZ_1,
    'Wpis do rejestru żłobków',
    false,
    'OP',
  ),
  new Application(
    1022,
    'OP',
    'RKZ-2',
    ApplicationCode.RKZ_2,
    'Zmiana danych w rejestrze żłobków',
    false,
    'OP',
  ),
  new Application(
    1023,
    'OP',
    'RKZ-3',
    ApplicationCode.RKZ_3,
    'Wykreślenie z rejestru żłobków',
    false,
    'OP',
  ),
  new Application(
    1027,
    'OP',
    'RKZ-4',
    ApplicationCode.RKZ_4,
    'Sprawozdanie z działalności żłobków',
    false,
    'OP',
  ),
  new Application(
    1070,
    'OP',
    'RKZ-5',
    ApplicationCode.RKZ_5,
    'Informacja o dzieciach uczęszczających do instytucji opieki',
    false,
    'OP',
  ),
  new Application(
    1079,
    'OP',
    'RKZ-6',
    ApplicationCode.RKZ_6,
    'Wniosek dla podmiotów innych niż gmina (Aktywny Maluch 2022-2029)',
    false,
    'OP',
  ),
  new Application(
    1080,
    'OP',
    'RKZ-7',
    ApplicationCode.RKZ_7,
    'Oświadczenie o przyjęciu dofinansowania (Aktywny Maluch 2022-2029)',
    false,
    'OP',
  ),
  new Application(
    1098,
    'OP',
    'RKZ-8',
    ApplicationCode.RKZ_8,
    'Informacja o standardach opieki',
    false,
    'OP',
  ),
];

export const TURNUSY_REHABILITACYJNE_APPLICATION_LIST = [
  new Application(
    1010,
    'ON',
    'ON-1',
    ApplicationCode.ON_1,
    'Wpis do rejestru organizatorów turnusów rehabilitacyjnych',
    false,
    'ON',
  ),
  new Application(
    1011,
    'ON',
    'ON-2',
    ApplicationCode.ON_2,
    'Wpis do rejestru ośrodków turnusów rehabilitacyjnych',
    false,
    'ON',
  ),
];

export const ORGANIZACJA_APPLICATION_LIST = [
  new Application(
    1021,
    'OP',
    'RKZ-1',
    ApplicationCode.RKZ_1,
    'Wpis do rejestru żłobków',
    false,
    'OP',
  ),
  new Application(
    1022,
    'OP',
    'RKZ-2',
    ApplicationCode.RKZ_2,
    'Zmiana danych w rejestrze żłobków',
    false,
    'OP',
  ),
];

export const ZS_6_APPLICATION: Application = new Application(
  1004,
  'ZS',
  'ZS-6',
  ApplicationCode.ZS_6,
  'Korespondencja w sprawie do jednostki terenowej',
  true,
  'ZS',
);

export const APPLICATIONS: Record<APPLICATION_CATEGORY, Application[]> = {
  [SwiadczeniobiorcyFilter.AKTYWNY_RODZIC]: AKTYWNY_RODZIC_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.DOBRY_START]: DOBRY_START_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.SWIADCZENIE_WYCHOWAWCZE]:
    SWIADCZENIA_WYCHOWAWCZE_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.SWIADCZENIE_RODZINNE]:
    SWIADCZENIA_RODZINNE_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.KARTA_DUZEJ_RODZINY]:
    KARTA_DUZEJ_RODZINY_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.FUNDUSZ_ALIMENTACYJNY]:
    FUNDUSZ_ALIMENTACYJNY_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.POMOC_SPOLECZNA]: POMOC_SPOLECZNA_APPLICATION_LIST,
  [SwiadczeniobiorcyFilter.SWIADCZENIA_WSPIERAJACE]:
    SWIADCZENIA_WSPIERAJACE_APPLICATION_LIST,
  [PrzedsiebiorcyFilter.OPIEKA_NAD_DZIECKIEM_DO_LAT_3]:
    OPIEKA_NAD_DZIECKIEM_DO_LAT_3_APPLICATION_LIST,
  [PrzedsiebiorcyFilter.TURNUSY_REHABILITACYJNE]:
    TURNUSY_REHABILITACYJNE_APPLICATION_LIST,
};

export const ALL_APPLICATIONS_FLAT: Application[] =
  Object.values(APPLICATIONS).flat();
